module.exports = __webpack_public_path__ + "img/aq.f21f5aa7.svg";